var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDropbox = function SvgDropbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#0061FF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.015 6.574-5.508 3.573 5.508 3.574-5.508 3.574L1 13.69l5.507-3.573L1 6.574 6.507 3l5.508 3.574ZM6.478 18.426l5.507-3.573 5.508 3.573L11.985 22l-5.507-3.574Zm5.537-4.735 5.507-3.573-5.507-3.544L17.493 3 23 6.574l-5.507 3.573L23 13.721l-5.507 3.574-5.478-3.604Z"
  })));
};

export default SvgDropbox;